var _path, _rect, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8201 29.8903H11.4942C9.57054 29.8903 8.01108 28.3308 8.01108 26.4071V4.81161C8.01108 2.88792 9.57054 1.32847 11.4942 1.32847H20.7843L30.3032 10.8474V26.4071C30.3032 28.3308 28.7438 29.8903 26.8201 29.8903Z",
    fill: "#EEF1F7",
    stroke: "#CBD0DC",
    strokeWidth: 1.39326
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13.8672,
    width: 20.8989,
    height: 12.191,
    rx: 2.4382,
    fill: "#D82042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46289 22.925V17.0986H5.53967C5.99295 17.0986 6.36848 17.1811 6.66625 17.3461C6.96401 17.5111 7.18686 17.7368 7.3348 18.0232C7.48273 18.3077 7.5567 18.6282 7.5567 18.9848C7.5567 19.3433 7.48179 19.6657 7.33195 19.9521C7.18402 20.2366 6.96022 20.4623 6.66056 20.6292C6.36279 20.7942 5.98821 20.8767 5.53682 20.8767H4.10868V20.1313H5.45717C5.74355 20.1313 5.97589 20.082 6.15417 19.9834C6.33245 19.8828 6.46331 19.7463 6.54676 19.5737C6.63021 19.4011 6.67194 19.2048 6.67194 18.9848C6.67194 18.7648 6.63021 18.5694 6.54676 18.3988C6.46331 18.2281 6.3315 18.0943 6.15132 17.9976C5.97304 17.9009 5.73786 17.8525 5.44579 17.8525H4.34196V22.925H3.46289Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4734 22.925H8.58727V17.0986H10.5332C11.1041 17.0986 11.5943 17.2153 12.004 17.4486C12.4137 17.6799 12.7275 18.0128 12.9457 18.4471C13.1657 18.8795 13.2757 19.3983 13.2757 20.0033C13.2757 20.6102 13.1647 21.1318 12.9428 21.568C12.7228 22.0042 12.4042 22.3399 11.9869 22.5751C11.5697 22.8083 11.0652 22.925 10.4734 22.925ZM9.46634 22.1569H10.4251C10.8689 22.1569 11.2378 22.0734 11.5317 21.9065C11.8257 21.7377 12.0457 21.494 12.1918 21.1754C12.3378 20.8548 12.4108 20.4641 12.4108 20.0033C12.4108 19.5462 12.3378 19.1583 12.1918 18.8397C12.0476 18.5211 11.8323 18.2793 11.546 18.1143C11.2596 17.9493 10.904 17.8668 10.4791 17.8668H9.46634V22.1569Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3688 22.925V17.0986H17.9818V17.8554H15.2479V19.6306H17.7229V20.3845H15.2479V22.925H14.3688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.a43f4a11a0758da4775fb68fd645a104.svg";
export { ForwardRef as ReactComponent };